import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useHistory, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import SaveBundle from "../../../components/Forms/SaveBundle";
import RouteLeavingGuard from "../../../routes/middleware/RouteLeavingGuard";

import {
  clearReferralSourceFetched,
  getReferralSource,
  updateReferralSource,
} from "../../../store/dashboard/ReferralSources/actions";
import ScrollbarVertical from "../../../components/Common/ScrollbarVertical";
import ProgressWatcher from "../../../components/Common/ProgressWatcher";
import SEO from "../../../components/Common/SEO";
import SaveReferralSource from '../../../components/Forms/SaveReferralSource';

const PROGRESS_TEXT = "Files are uploading now. Please, don't quit this page";

const Update = ({
  clearReferralSourceFetched,
  getReferralSource,
  updateReferralSource,
  referralSources,
}) => {
  const { updated, item, loading } = referralSources;
  const [isDirty, updateDirty] = useState(false);
  const [ready, updateReadyState] = useState(false);
  const {
    params: { referralSourceId },
  } = useRouteMatch("/referral-sources/:referralSourceId");
  const history = useHistory();
  const saveReferralSourceCallback = useCallback(
    (model) => {
      updateReferralSource({ referralSourceId, model }, history);
    },
    [item]
  );
  const isBlocked = (updated ? false : isDirty);

  useEffect(() => {
    if (!ready && referralSourceId && !loading) {
      getReferralSource(referralSourceId);
      updateReadyState(true);
    }
  }, [referralSourceId, ready, loading]);

  useEffect(() => {
    return () => {
      clearReferralSourceFetched();
    };
  }, []);

  return (
    <>
      <SEO title="Edit Referral Source" />
      <RouteLeavingGuard
        contentText="Changed data will not be saved. Are you sure you want to cancel?"
        when={isBlocked}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={() => {
          return isBlocked;
        }}
      />
      <ProgressWatcher loading={loading} contentText={PROGRESS_TEXT} />
      <ScrollbarVertical>
        <Row className="page-content h-100">
          <Container fluid className="h-100">
            <Row>
              <Col xs="12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18 text-uppercase">
                    Edit Referral Source
                  </h4>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs="12" className="pb-4">
                {item && (
                  <SaveReferralSource
                    model={item}
                    saveReferralSourceFunc={saveReferralSourceCallback}
                    updateDirtyState={updateDirty}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </Row>
      </ScrollbarVertical>
    </>
  );
};

const mapStateToProps = ({ ReferralSources }) => {
  return { referralSources: ReferralSources };
};

export default connect(mapStateToProps, {
  clearReferralSourceFetched,
  getReferralSource,
  updateReferralSource,
})(Update);
